module.exports = __webpack_public_path__ + "static/10-ace39748e6a9524d4383c2a7b1a65c3f.jpg";